<template>
    <div class="NewsSingle"
        @mouseenter="state.isHovering = true"  
        @mouseleave="state.isHovering = false"
    >
        <!-- <ScrollForcer ref="scrollForcer" @onScrollForced="onScrollForced" :disable="state.isTweening"> -->
            <CustomScroll class="CustomScroll">
                    <div ref="custScrol" class="CustomScroll-content" :multiply-wheel="1">
                        <div class="NewsSingle-item" v-for="item in content">
                            <p v-if="item.slice_type == 'paragraphe'" class="NewsSingle-item is-text">{{item.primary.paragraph[0].text}}</p>
                            <picture v-if="item.slice_type == 'image'">
                                <source :srcset="item.primary.image.url" media="(min-width: 768px)">
                                <img class="NewsSingle-item is-img" :src="item.primary.image.mobile.url" alt="tbd">
                            </picture>
                            <div v-if="item.slice_type == 'video'" class="NewsSingle-item video-container">
                                <VideoPlayer :url="item.primary.video_link.url" :poster="item.primary.image_preview.url">
                                     <PlayerPlaceholder 
                                        client=""
                                        title=""
                                        :video="item.primary.video_preview.url"
                                        :mobile-image="item.primary.image_preview.mobile.url"
                                        :desktop-image="item.primary.image_preview.url"></PlayerPlaceholder>
                                </VideoPlayer>
                            </div>
                        </div>
                    </div>
            </CustomScroll>
        <!-- </ScrollForcer> -->
    </div>
</template>

<script>

import Store from '@/stores/store.js'
import Data from '@/data/data.js'

import CustomScroll from '@/components/CustomScroll.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import PlayerPlaceholder from '@/components/PlayerPlaceholder.vue'

export default {
    name: 'NewsSingle',
    components:{
        CustomScroll,
        VideoPlayer,
        PlayerPlaceholder
    },
    data(){
        return{
            state: Store.state
        }
    },
    created() {        
        this.news = Store.state.currentNews;
        this.content = this.news.data.body;
    },

    mounted(){
        /*
        if( !Store.isDesktop ){
            //In case image aren't load, listen for their laod event in order to recalculate the scroll height.
            [...this.$el.querySelectorAll('img')].forEach(element => {
                element.addEventListener('load',  ()=>{
                    this.onResize();
                })
            });
        } */
    },

    beforeRouteLeave (to, from, next) {
        Store.state.currentNews = null;
        next();
    },
    beforeRouteLeave (to, from, next) {
        Store.state.currentNews = null;
        next();
    },
    beforeRouteUpdate: (to, from, next) => {
        Data.getNewsBySlug(to.params.slug).then( (news) => {
            Store.state.currentNews = news;
            next();
        } )
    },
    methods: {
        onScrollForced(direction){
            const indexOfPos = Data.getNews().indexOf( this.news )

            if( direction === 'bottom'){
                if(  indexOfPos !== Data.getNews().length-1 ){
                    this.$router.push({ path: '/news/' + Data.getNews()[indexOfPos+1].slugs[0] });
                }
            }else{
                if(  indexOfPos !== 0 ){
                    this.$router.push({ path: '/news/' + Data.getNews()[indexOfPos-1].slugs[0] });
                }
            }
        },
        enterAnimMobile(done){
            TweenMax.from(this.$el, 0.6, {height: 0, ease: Power3.easeOut, onComplete: done });
        },

        leaveAnimMobile(done){
            TweenMax.to(this.$el, 0.6, { height: 0, ease: Power3.easeOut, onComplete: done });
        },

        onResize(){
            this.contentHeight = this.$refs.custScrol.clientHeight;
            TweenMax.to(this.$el, 0.6, {height: this.contentHeight, ease: Power3.easeOut });
        },

        enterAnim(done){
            setTimeout(() => {
                done();
            }, 700);
        },

        leaveAnim(done){
            setTimeout(() => {
                done();
            }, 700);
        },
    },
}
</script>


<style lang="scss">
    .NewsSingle{
        position: fixed;
        right: 0;
        top: 0;
        height: 100%;
        width: 50%;
        padding: 0 70px 0 0;
        opacity: 1;
        transition: opacity 1s linear;

        z-index: zindex(realisations);
        
        .CustomScroll{
            height: 100%;
            overflow: hidden;

            &-content{
                padding: 40px 0;
            }
        }

        img{
            width: 100%;
            height: auto;

            transform: translateZ(0);
        }

        p{
            margin-top: 20px;
            text-transform: initial;

            @include respond-to(md){
                margin-top: 15px;
                font-size: rem(14px);
            }
        }

        .video-container{
            width: 100%;
            @include aspect-ratio(16,9);
            background-color: color(black);
            transform: translateZ(0);
        }

        &-item{
            margin-bottom: 20px;
            @include respond-to(md){
                margin-top: 15px;
            }
            &:last-child{
                margin-bottom: 0;
            }
            &.is-text{
                text-transform: none;
                font-variation-settings: "wght" 300, "wdth" 50;
                font-size: rem(17px);
                line-height: rem(25px);
                color: #BBB;
            }
        }
    }


    .NewsSingle.v-enter-active{
            .NewsSingle-item{
                @for $i from 1 through 4 {
                    transition: transform .8s $ease-out-quint;
                    &:nth-child(#{$i}){
                        transition-delay: (0.025s * $i);
                    }
                    .PlayerPlaceholder-image{
                        transform-origin: top left;
                        transition: transform 1s $ease-out-quint;
                        transition-delay: (0.025s * $i);
                    }
                }
            }
    }
    .NewsSingle.v-leave-active{
            .NewsSingle-item{
                @for $i from 1 through 4 {
                    transition: transform .4s $ease-out-quint;
                    &:nth-child(#{$i}){
                        transition-delay: (0.025s * $i);
                    }
                    .PlayerPlaceholder-image{
                        transform-origin: top left;
                        transition: transform .4s $ease-out-quint;
                        transition-delay: (0.025s * $i);
                    }
                }
            }
    }
    
    .NewsSingle.v-enter, .NewsSingle.v-leave-to {
            opacity: 0.99;
            .NewsSingle-item{
                transform: translateX(100%) translateZ(0);
            }
            .NewsSingle-item > img{
                transform-origin: top left;
                transform: scaleX(2) translateZ(0);
            }
            .PlayerPlaceholder-image{
                transform: scaleX(2) translateZ(0);
            }
    }

    .isTouch {
        .NewsSingle{
                position: absolute;
                width: 100%;
                height: calc(100% - 65px);
                padding: 0 0;
                top: 65px;
                overflow: hidden;
            
            
            .CustomScroll{
                overflow-y: auto;
                overflow-x: hidden;
                &-content{
                    padding-bottom: 30px;

                }
            }

            .ScrollForcer{
                height: auto;
            }

            p{
                margin-top: 15px;
                padding: 0 20px;
                font-size: rem(14px);
            }

            &-item{
                margin-top: 15px;
            }
        }
    }
</style>
